import React from 'react';
import { useServerMessages } from '../../../comms/server-messages/useServerMessagesHook.js';
import { Stack } from 'react-bootstrap';
import { SMSnapshotItem } from './SMSnapshotItem.js';
import { parseServerMessagesForI18n } from './helpers/server-message-helpers.js';
import { SHXCol } from '@soulhx/ui-common';
import { useTranslation } from 'react-i18next';

export const ServerMessageSnapshot = () => {
  const { t } = useTranslation(['comms']);
  const { messages } = useServerMessages();

  if (messages.length < 1) return null;

  parseServerMessagesForI18n(messages);

  return (
    <SHXCol grow={1} minWidth="400px">
      <h5 className="text-center">{t('comms:serverMessages.title')}</h5>

      <Stack gap={1}>
        {messages.map((item) => (
          <SMSnapshotItem key={item.id} sm={item} />
        ))}
      </Stack>
    </SHXCol>
  );
};
